import { render, staticRenderFns } from "./CitizensFilters.vue?vue&type=template&id=6c8e9eae&scoped=true"
import script from "./CitizensFilters.vue?vue&type=script&lang=js"
export * from "./CitizensFilters.vue?vue&type=script&lang=js"
import style0 from "./CitizensFilters.vue?vue&type=style&index=0&id=6c8e9eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e9eae",
  null
  
)

export default component.exports